const initialState = {
    countData: {},
    tableData: []
}
export default function OrganizationReducer(state = initialState, action) {
    switch (action.type) {
        case 'GET_ADMIN_DASHBOARD_COUNT_SUCCESS':
            return {
                ...state,
                countData: formatCountValue(action.payload),
            }
        case 'GET_ORG_ADMIN_DASHBOARD_USERS_DATA_SUCCESS':
            return {
                ...state,
                tableData: formatUserData(action.payload),
            }
        case 'RESET_ADMIN_DASHBOARD_COUNT':
            return {
                ...state,
                countData: {},
            }
        case 'RESET_ADMIN_DASHBOARD_TABLE_DATA':
            return {
                ...state,
                tableData: [],
            }
        default:
            return state
    }
}

const formatCountValue = (value) => {
    return {
        no_of_users: value?.users,
        completed: value?.completed_users,
        pending: value?.pending_tasks_users,
        organizations: value?.organisations
    }
}

const formatUserData = (data) => {
    return data
}